import { SvgIcon, SvgIconProps } from "@mui/material";

const GivenchyCheckBoxDefault = (props: SvgIconProps) => (
  <SvgIcon
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="1.5" width="14" height="14" fill="white" stroke="black" />
  </SvgIcon>
);

export default GivenchyCheckBoxDefault;
